export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

/** Cookie used only by a direct tenant-workspace browser window. */
export function getTenantSessionCookieName(workspaceSlug: string): string {
  const safeSlug = workspaceSlug.trim().toLowerCase().replace(/[^a-z0-9_-]/g, "-").slice(0, 80);
  return `${COOKIE_NAME}_tenant_${safeSlug}`;
}
